import Vue from 'vue'
import Vuex from 'vuex'

import {getField, updateField} from 'vuex-map-fields'

Vue.use(Vuex)
export const store = new Vuex.Store({
    state:{
        //general
        currentNav:'front',
        username:'',
        oldpassword:'',
        loggedInUser:{
            id:0,
            name:'',
        },
        securityAppName:'MobileIDAdmin',
        securityAppItems:[],
        loggedIn:false,
        token:null,
        didFailAuth:false,
        storeLogin:false,
        
        badgeData:{},
        logoOverride:'',
        configOverride:'',
        locations:[],
        departments:[],
        alertTemplateList:[],
        personRoleList:[],
        messageTemplateList:[],
        smsTemplateList:[],
        showHeader:true,
        showHeaderFromURL:true,


    },
    mutations:{
        updateField,
        failAuth(state){
            state.loggedIn=false;
            state.didFailAuth=true;
        },
    },
    getters:{
        getField,
    },
    actions:{
        failedAuthLogout(context){
            context.commit('failAuth'); 
        },
    }
})